module.exports = __webpack_public_path__ + "1ddb573f720a2bb826eeade502eff8b7.MP3";